import { render, staticRenderFns } from "./PrizeNumber.vue?vue&type=template&id=5b86aee9&scoped=true"
import script from "./PrizeNumber.vue?vue&type=script&lang=js"
export * from "./PrizeNumber.vue?vue&type=script&lang=js"
import style0 from "./PrizeNumber.vue?vue&type=style&index=0&id=5b86aee9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86aee9",
  null
  
)

export default component.exports